import script from "./AgentRules.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentRules.vue?vue&type=script&lang=ts&setup=true"

import "./AgentRules.vue?vue&type=style&index=0&id=1ae38b7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae38b7b"]])

export default __exports__